import { Container } from '@chakra-ui/react'
import { Prose } from '@nikolovlazar/chakra-ui-prose'
import { useEffect, useRef } from 'react'

// Add ids to headings
const addIds = (node: HTMLElement) => {
  if (node.tagName === 'H2') {
    node.id = node.textContent
      ? node.textContent
          .toLowerCase()
          .replace(/[^\da-z]+/g, '-')
          .replace(/(^-|-$)+/g, '')
      : ''
  }
}

type TextBlockProps = {
  text: string
  textAlign: 'left' | 'center' | 'right'
}

export const TextBlock = (props: TextBlockProps) => {
  // Add ids to headings
  const ref = useRef(null)

  useEffect(() => {
    // Guard
    if (!ref.current) return

    const refCurrent = ref.current as HTMLElement

    const nodes = refCurrent.querySelectorAll('h2')
    nodes.forEach(node => addIds(node))
  }, [])

  return (
    <>
      <Container maxWidth='4xl'>
        <Prose>
          <div
            ref={ref}
            style={{ textAlign: props.textAlign }}
            dangerouslySetInnerHTML={{ __html: props.text }}
          />
        </Prose>
      </Container>
    </>
  )
}

export default TextBlock
